import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../../services/api";

function PrivateRoute() {
    if (!isAuthenticated())
        return <Navigate to="/login" replace />;

    return <Outlet />;
}

export default PrivateRoute;